import React, { useState, useEffect } from 'react'
import styles from './Navbar.module.css'
import { useLang } from '../../i18n/LanguageContext'

const NAV_HREFS = [
  { key: 'about',     href: '#sobre' },
  { key: 'history',   href: '#historia' },
  { key: 'solutions', href: '#solucoes' },
  { key: 'clients',   href: '#clientes' },
  { key: 'contact',   href: '#contato' },
]

export default function Navbar() {
  const { lang, setLanguage, T } = useLang()
  const [scrolled, setScrolled] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const handleLink = () => setOpen(false)

  return (
    <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}>
      <div className={`container ${styles.inner}`}>
        {/* Logo */}
        <a href="#" className={styles.logo} aria-label="EQPI Tech — início">
          <img src="/logos/Logo_EQPI.svg" alt="EQPI Tech" className={styles.logoImg} />
        </a>

        {/* Desktop links */}
        <ul className={styles.links} role="list">
          {NAV_HREFS.map((l) => (
            <li key={l.href}>
              <a href={l.href} className={styles.link}>{T.nav[l.key]}</a>
            </li>
          ))}
        </ul>

        {/* Language switch */}
        <div className={styles.langSwitch} aria-label="Idioma / Language">
          <button
            className={`${styles.langBtn} ${lang === 'pt' ? styles.langActive : ''}`}
            onClick={() => setLanguage('pt')}
            aria-pressed={lang === 'pt'}
          >PT</button>
          <span className={styles.langDivider} aria-hidden="true">|</span>
          <button
            className={`${styles.langBtn} ${lang === 'en' ? styles.langActive : ''}`}
            onClick={() => setLanguage('en')}
            aria-pressed={lang === 'en'}
          >EN</button>
        </div>

        {/* CTA */}
        <a href="#contato" className={`btn btn-primary ${styles.cta}`}>
          {T.nav.cta}
        </a>

        {/* Hamburger */}
        <button
          className={styles.hamburger}
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? T.nav.closeMenu : T.nav.openMenu}
          aria-expanded={open}
        >
          <span className={`${styles.bar} ${open ? styles.barTop : ''}`} />
          <span className={`${styles.bar} ${open ? styles.barMid : ''}`} />
          <span className={`${styles.bar} ${open ? styles.barBot : ''}`} />
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className={styles.drawer}>
          {NAV_HREFS.map((l) => (
            <a key={l.href} href={l.href} className={styles.drawerLink} onClick={handleLink}>
              {T.nav[l.key]}
            </a>
          ))}
          <div className={styles.drawerBottom}>
            <div className={styles.drawerLang}>
              <button
                className={`${styles.langBtn} ${lang === 'pt' ? styles.langActive : ''}`}
                onClick={() => setLanguage('pt')}
              >PT</button>
              <span className={styles.langDivider} aria-hidden="true">|</span>
              <button
                className={`${styles.langBtn} ${lang === 'en' ? styles.langActive : ''}`}
                onClick={() => setLanguage('en')}
              >EN</button>
            </div>
            <a href="#contato" className={`btn btn-primary ${styles.drawerCta}`} onClick={handleLink}>
              {T.nav.cta}
            </a>
          </div>
        </div>
      )}
    </nav>
  )
}
